module.exports = __webpack_public_path__ + "static/media/leaf-heart.26b6ea83.svg";